import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { StaffIcon } from 'components/Atoms/Icon';
import { USER_ROLES } from 'constants/common';

const StaffManagement = lazy(() => import('modules/staff/Staff'));

export const staffRoutes = [
  {
    path: routePath.STAFF,
    component: StaffManagement,
    exact: true,
    name: routeName.STAFF,
    showMenu: true,
    icon: StaffIcon,
    roles: [USER_ROLES.ADMIN],
    breadcrumbs: [{ name: routeName.STAFF }],
  },
];
